import { Box, IconButton, Button, Typography, Chip, Paper } from "@mui/material";
import { Add, Delete, ArrowUpward, ArrowDownward } from "@mui/icons-material";
import AnswerOptionRichEditor from "./AnswerOptionRichEditor";

const OrderingEditor = ({ options, setOptions }) => {
  const handleChange = (index, value) => {
    const updated = [...options];
    updated[index] = { ...updated[index], text: value };
    setOptions(updated);
  };

  const addItem = () => {
    if (options.length < 10) {
      setOptions([...options, { text: "" }]);
    }
  };

  const removeItem = (index) => {
    if (options.length <= 2) return;
    setOptions(options.filter((_, i) => i !== index));
  };

  const moveUp = (index) => {
    if (index === 0) return;
    const updated = [...options];
    [updated[index - 1], updated[index]] = [updated[index], updated[index - 1]];
    setOptions(updated);
  };

  const moveDown = (index) => {
    if (index >= options.length - 1) return;
    const updated = [...options];
    [updated[index], updated[index + 1]] = [updated[index + 1], updated[index]];
    setOptions(updated);
  };

  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600, color: "#444" }}>
        Items in Correct Order (enter items in the correct sequence)
      </Typography>
      {options.map((opt, index) => (
        <Paper
          key={index}
          elevation={0}
          sx={{ 
            display: "flex",
            alignItems: "flex-start",
            gap: 1,
            mb: 1.5,
            p: 1,
            border: "1px solid #e0e0e0",
            borderRadius: 1,
            background: "#fafafa",
          }}
        >
          <Chip 
            label={index + 1} 
            size="small" 
            sx={{ 
              minWidth: 32,
              background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
              color: "#fff",
              fontWeight: 600,
            }} 
          />
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <AnswerOptionRichEditor
              value={opt.text}
              onChange={(html) => handleChange(index, html)}
              placeholder={`Item ${index + 1}`}
            />
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <IconButton size="small" onClick={() => moveUp(index)} disabled={index === 0} sx={{ color: "#6366f1" }}>
              <ArrowUpward fontSize="small" />
            </IconButton>
            <IconButton size="small" onClick={() => moveDown(index)} disabled={index >= options.length - 1} sx={{ color: "#6366f1" }}>
              <ArrowDownward fontSize="small" />
            </IconButton>
          </Box>
          <IconButton
            size="small"
            color="error"
            onClick={() => removeItem(index)}
            disabled={options.length <= 2}
          >
            <Delete fontSize="small" />
          </IconButton>
        </Paper>
      ))}
      <Button 
        size="small" 
        startIcon={<Add />} 
        onClick={addItem} 
        disabled={options.length >= 10}
        sx={{ 
          color: "#6366f1",
          "&:hover": { background: "rgba(99, 102, 241, 0.08)" }
        }}
      >
        Add Item
      </Button>
    </Box>
  );
};

export default OrderingEditor;
